import { render } from "./RegistrationQuoteBlockComponent.vue?vue&type=template&id=213c1b56&scoped=true"
import script from "./RegistrationQuoteBlockComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationQuoteBlockComponent.vue?vue&type=script&lang=js"

import "./RegistrationQuoteBlockComponent.vue?vue&type=style&index=0&id=213c1b56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213c1b56"]])

export default __exports__